import React from "react";
import { Image } from "repoV2/components/common/Image";
import { IAddressInfo } from "./IAddressInfo";
import styles from "./addressinfo.module.scss";
import commonStyles from "../commonStyles.module.scss";

const AddressInfo = ({
    hideComponent,
    icon,
    title,
    description,
}: IAddressInfo.IProps): JSX.Element | null => {
    if (hideComponent) return null;

    // TODO: Delete the following commented code, if it remains unsed till March 3, 2023
    /*
    // If there is a event type title set by the admin panel show that
    if (displayType) {
        return (
            <div className={eventModuleStyles.section}>
                <div>{displayType}</div>
            </div>
        );
    }
    */

    return (
        <div className={commonStyles.detailsSection}>
            <div className={styles.addressRow}>
                <Image
                    alt={title}
                    className={styles.addressIcon}
                    src={icon}
                    disableShimmerFunctionality
                    width={32}
                    height={32}
                />
                <div className={styles.addressCol}>
                    <div className={styles.primary}>{title}</div>
                    <div className={styles.secondary}>{description}</div>
                </div>
            </div>
        </div>
    );
};

export default AddressInfo;
